import moment from "moment"

export const formatDateForServer = (date: string | null): string | null => (
  date ? moment(date, 'DD.MM.YYYY').format('YYYY-MM-DD') : null
)

export const formatDateForClient = (date: string | null): string | null => (
  date ? moment(date, 'YYYY-MM-DD').format('DD.MM.YYYY') : null
)